var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "cover_x2C__credit_x2C__card_x2C__visa_x2C__electron"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M495.951,389.952c0,8.842-7.123,16.051-15.959,16.051H32.008    c-8.836,0-15.959-7.209-15.959-16.051V121.956c0-8.836,7.123-15.959,15.959-15.959h447.984c8.836,0,15.959,7.123,15.959,15.959    V389.952L495.951,389.952z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#075FA0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.639,274.896c36.341-15.516,87.289-29.669,154.83-15.516    l0.629-17.13c-71.146-7.757-122.276,14.967-155.459,31.019V274.896L177.639,274.896z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBAA28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.081,287.521 146.35,287.521 146.35,297.798     125.067,297.798 124.978,307.354 146.168,307.354 146.168,317.183 124.889,317.183 124.978,326.739 145.896,326.739     145.896,337.022 112.174,337.022   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.914,283.368 167.361,283.368 167.45,337.022     155.003,337.022   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.282,332.963c-4.238,3.604-10.729,5.409-16.411,5.409    c-13.075,0-19.027-9.285-19.027-18.577c0-10.906,8.115-20.105,19.388-20.105c13.707,0,18.032,9.742,18.032,22.096h-24.977    c0,2.792,1.806,7.573,8.657,7.573c4.329,0,6.763-1.355,10.188-3.611L210.282,332.963L210.282,332.963z M201.083,314.478    c0-3.697-1.803-7.03-5.951-7.03c-3.965,0-6.941,3.519-7.755,7.03H201.083L201.083,314.478z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.047,334.589c-3.426,2.163-9.106,3.783-13.254,3.783    c-11.454,0-19.658-6.58-19.658-18.484c0-12.17,8.114-20.198,20.469-20.198c4.328,0,9.467,1.356,12.265,3.155l-4.058,8.121    c-1.805-0.728-3.879-1.355-5.862-1.355c-6.221,0-10.37,3.696-10.37,9.648c0,5.14,4.058,9.199,9.289,9.199    c2.344,0,4.777-1.084,6.762-2.076L250.047,334.589L250.047,334.589z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.646,300.952h5.682l-0.09-12.175h11.994l-0.27,12.175    h10.277l-0.27,9.016h-10.191c0,5.053-0.359,10.369-0.359,13.438c0,3.155,0.813,4.598,3.607,4.598c1.713,0,3.158-0.814,4.508-1.714    l2.797,8.479c-3.697,2.255-8.117,3.604-12.354,3.604c-10.1,0-10.643-6.401-10.643-14.695c0-4.418,0.361-8.836,0.361-13.709h-5.321    L254.646,300.952L254.646,300.952z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.641,300.952h12.447v5.139h0.086    c1.893-3.068,4.332-6.13,9.199-6.13c1.355,0,2.799,0.179,4.061,0.45l-1.625,12.354c-1.264-0.363-2.613-0.721-4.418-0.721    c-4.146,0-7.395,3.426-7.395,4.146l-0.271,20.832h-12.439L288.641,300.952L288.641,300.952z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.973,299.689c13.348,0,20.199,8.479,20.199,19.298    c0,10.912-6.852,19.385-20.199,19.385c-13.252,0-20.197-8.473-20.197-19.385C316.775,308.168,323.721,299.689,336.973,299.689    L336.973,299.689z M336.973,328.908c5.953,0,7.758-5.145,7.758-9.921c0-4.688-1.805-9.828-7.758-9.828    c-5.951,0-7.664,5.141-7.664,9.828C329.309,323.764,331.021,328.908,336.973,328.908L336.973,328.908z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.938,300.952h12.447v3.969    c2.883-2.797,7.301-5.231,11.719-5.231c7.664,0,11.811,4.239,11.811,14.067c0,7.395-0.086,15.33-0.178,23.266h-12.447    c0.094-6.943,0.18-13.888,0.18-21.375c0-2.975-0.807-5.23-4.504-5.23c-2.076,0-4.869,1.719-6.58,3.34v23.266h-12.719    L363.938,300.952L363.938,300.952z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.611,226.648 230.299,174.799 244.369,174.799     228.586,226.648   ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.299,174.799l-18.578,34.266h-0.271    c0.271-4.598-0.357-10.278-0.45-13.439l-1.353-20.826h-23.623l-0.271,1.355c6.042,0,9.646,3.063,10.639,9.285l4.6,41.209H193.6    l29.397-51.85H208.299L208.299,174.799z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.496,226.648l-0.357-7.757h-17.586l-3.518,7.757h-15.238    l27.594-51.758h18.756l4.688,51.758H317.496L317.496,226.648z M315.877,196.081c-0.094-3.882-0.271-9.106,0-12.262h-0.186    c-0.9,2.612-4.504,10.37-6.131,14.153l-5.23,11.362h12.268L315.877,196.081L315.877,196.081z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.154,228.091c-9.917,0-16.498-3.063-21.19-5.952    l6.674-10.191c4.149,2.348,7.482,5.053,15.151,5.053c2.434,0,4.779-0.635,6.131-2.884c1.984-3.426-0.453-5.231-5.953-8.3    l-2.705-1.799c-8.117-5.595-11.633-10.82-7.843-20.02c2.522-5.952,8.925-10.37,19.567-10.37c7.393,0,14.248,3.155,18.307,6.31    l-7.758,9.021c-3.877-3.161-7.123-4.781-10.82-4.781c-2.977,0-5.229,1.084-6.041,2.705c-1.443,2.89,0.453,4.867,4.777,7.486    l3.248,2.076c9.828,6.218,12.172,12.712,9.738,18.843C276.197,225.743,267.813,228.091,259.154,228.091L259.154,228.091z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.996ebe43.svg";
export { ForwardRef as ReactComponent };